import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

export interface IQrLoginCode {
	Image:string;
	Expires:number;
}

class QrLoginServiceClass {
	private readonly baseUrl:string = `${ServerConfig.auth}/auth/qr-login`;
	public readonly VISIBLE_SECONDS = 300;

	public async createCode():Promise<IQrLoginCode>{
		let result = await Axios.post(`${this.baseUrl}/create`, {});
		return result.data;
	}
}

export const QrLoginService = new QrLoginServiceClass();
